import { authAPI } from '../services/api';

/**
 * Returns true if the current user is a demo viewer (read-only access).
 * Use this to conditionally hide write actions (buttons, forms, nav items).
 */
export function useIsViewer(): boolean {
  const user = authAPI.getCurrentUser();
  return user?.role === 'viewer';
}

/**
 * True only for the anonymous demo session (its token and user carry `is_demo: true`).
 * Drives the demo lockdown — banner, watermark, print/selection block, dev-tools blur.
 * NOT the same as the Viewer role: a real customer onboarded as a Viewer is read-only but is not a
 * demo prospect, and was wrongly shown all of this until 2026-09-27 (F11).
 */
export function useIsDemoSession(): boolean {
  const user = authAPI.getCurrentUser() as { is_demo?: boolean } | null;
  return user?.is_demo === true;
}
